import { fileNames } from 'Constants/imageUrls';

export const hpBackgrounds = {
    mobile: {
        ug: fileNames.HERO_BG_UG,
        ke: fileNames.HERO_BG_KE,
        gh: fileNames.HERO_BG_GH
    },
    desktop: {
        'in': fileNames.HERO_BG_IN,
        pk: fileNames.HERO_BG_PK,
        id: fileNames.HERO_BG_ID,
        ar: fileNames.HERO_BG_AR,
        co: fileNames.HERO_BG_CO,
        cr: fileNames.HERO_BG_CR,
        ec: fileNames.HERO_BG_EC,
        gt: fileNames.HERO_BG_GT,
        pa: fileNames.HERO_BG_PA,
        pe: fileNames.HERO_BG_PE,
        sv: fileNames.HERO_BG_SV,
        za: fileNames.HERO_BG_ZA,
        'default': fileNames.HERO_BG_OLX
    }
};
